import { render, staticRenderFns } from "./DuctpieceIndex.vue?vue&type=template&id=a174ff10&scoped=true&"
import script from "./DuctpieceIndex.vue?vue&type=script&lang=js&"
export * from "./DuctpieceIndex.vue?vue&type=script&lang=js&"
import style0 from "./DuctpieceIndex.vue?vue&type=style&index=0&id=a174ff10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a174ff10",
  null
  
)

export default component.exports